module.exports = __webpack_public_path__ + "static/media/esb-networks.8889638e.png";